import loginModule from '@breakmedia/prime-vue-customer/src/store/login';
import customerModule from '../store/customer';
import Login from '@breakmedia/prime-vue-customer/src/Login/LoginForm';

export default {
    install(Vue) {
        if (!Vue.$store.state['Login']) {
            Vue.$store.registerModule('Login', loginModule);
        }
        if (!Vue.$store.state['Customer']) {
            Vue.$store.registerModule('Customer', customerModule);
        }

        Vue.$router.onReady(() => {
            if (Vue.$router.currentRoute.query['reset-password-token']) {
                Vue.$store.commit('Login/setShowLoginModal', true);
            }
        });

        Vue.$router.beforeEach((to, from, next) => {
            if (to.query.login) {
                Vue.$router.replace({
                    ...to,
                    query: {
                        ...to.query,
                        login: undefined,
                    },
                });

                Vue.$store.commit(Login.name + '/setShowLoginModal', true);
            }

            next();
        });
    },
};
